.section[data-with-border] {
    border-color: var(--mantine-color-default-border);
}
